import React, { useState, useRef } from 'react';
import { Send, ThumbsUp, ThumbsDown, Bot, User, ArrowLeft, MessageCircle } from 'lucide-react';
import './ViewConversationsMockup.css';
import './PublicChatInterface.css';

const ViewConversationsMockup = () => {
  const messagesEndRef = useRef(null);
  const [selectedConversation, setSelectedConversation] = useState(0);
  
  const conversations = [
    {
      id: 1,
      title: "How do I become a better writer?",
      user: "Sarah Johnson",
      lastMessage: "Thank you for the advice!",
      timestamp: "2 hours ago",
      messages: [
        {
          id: 1,
          type: 'user',
          content: "I've been struggling with my writing lately. What's the key to becoming a better writer?",
          timestamp: "2:15 PM"
        },
        {
          id: 2,
          type: 'bot',
          content: "The key to becoming a great writer is simple but not easy: write a lot and read even more. Writing is a craft, and like any craft, it demands practice, patience, and a willingness to fail and learn from those failures. The stories that stick with readers come from a place of honesty, where personal experience and genuine curiosity meet discipline.",
          timestamp: "2:16 PM",
          feedback: null
        },
        {
          id: 3,
          type: 'user',
          content: "Should I read books outside of my genre?",
          timestamp: "2:18 PM"
        },
        {
          id: 4,
          type: 'bot',
          content: "Absolutely! Reading outside your genre is one of the best ways to grow as a writer. It broadens your understanding of different storytelling techniques, styles, and voices. You'll pick up unexpected ideas and learn how to handle elements like pacing, character development, and dialogue in fresh ways.",
          timestamp: "2:19 PM",
          feedback: null
        },
        {
          id: 5,
          type: 'user',
          content: "Thank you for the advice!",
          timestamp: "2:20 PM"
        }
      ]
    },
    {
      id: 2,
      title: "Career advice for developers",
      user: "Mike Chen",
      lastMessage: "That makes sense, thanks!",
      timestamp: "4 hours ago",
      messages: [
        {
          id: 1,
          type: 'user',
          content: "I'm a junior developer looking to advance my career. Any advice?",
          timestamp: "1:30 PM"
        },
        {
          id: 2,
          type: 'bot',
          content: "Focus on building strong fundamentals in your chosen technology stack, contribute to open source projects, and don't be afraid to take on challenging tasks that push you out of your comfort zone. Also, soft skills like communication and problem-solving are just as important as technical skills.",
          timestamp: "1:31 PM"
        },
        {
          id: 3,
          type: 'user',
          content: "That makes sense, thanks!",
          timestamp: "1:35 PM"
        }
      ]
    }
  ];

  const [newMessage, setNewMessage] = useState('');

  const handleSendMessage = () => {
    if (newMessage.trim()) {
      // In a real app, this would send the message
      setNewMessage('');
    }
  };

  const handleFeedback = (messageId, feedbackType) => {
    const conversation = conversations[selectedConversation];
    const message = conversation.messages.find(msg => msg.id === messageId);
    if (message) {
      message.feedback = message.feedback === feedbackType ? null : feedbackType;
    }
  };

  return (
    <div className="view-conversations-mockup" data-theme="dark">
      {/* Header */}
      <div className="view-conversations-header">
        <button className="view-conversations-back-btn">
          <ArrowLeft size={16} />
          Back to Conversations
        </button>
        <div className="view-conversations-info">
          <h2>Conversation with {conversations[selectedConversation].user}</h2>
        </div>
      </div>

      {/* Messages List */}
      <div className="view-conversations-messages">
        {conversations[selectedConversation].messages.map((message) => (
          <div key={message.id} className={`view-conversations-message ${message.type === 'user' ? 'user' : 'bot'}`}>
            {message.type === 'user' && (
              <div className="view-conversations-avatar">
                <div className="user-avatar-mockup">
                  {conversations[selectedConversation].user.charAt(0).toUpperCase()}
                </div>
              </div>
            )}
            <div className="view-conversations-message-content">
              <div className="view-conversations-message-text">
                <div className="view-conversations-message-header">
                  <span className="message-sender">
                    {message.type === 'user' ? conversations[selectedConversation].user : 'Agent'}
                  </span>
                  {message.type === 'bot' && (
                    <div className="view-conversations-feedback-icons">
                      <ThumbsUp 
                        className={`view-conversations-feedback-icon thumbs-up ${message.feedback === 'thumbs-up' ? 'selected' : ''}`}
                        onClick={() => handleFeedback(message.id, 'thumbs-up')}
                        size={18}
                      />
                      <ThumbsDown 
                        className={`view-conversations-feedback-icon thumbs-down ${message.feedback === 'thumbs-down' ? 'selected' : ''}`}
                        onClick={() => handleFeedback(message.id, 'thumbs-down')}
                        size={18}
                      />
                    </div>
                  )}
                </div>
                {message.content}
              </div>
            </div>
            {message.type === 'bot' && (
              <div className="view-conversations-avatar">
                <div className="view-conversations-bot-avatar">
                  <Bot size={20} />
                </div>
              </div>
            )}
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>

      {/* Owner Jump-in Input - reuse build-chat-mockup styling */}
      <div className="input-area">
        <div className="input-container">
          <input
            type="text"
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            placeholder="Respond as owner..."
            className="message-input"
            onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
          />
          <button onClick={handleSendMessage} className="send-button">
            <Send size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewConversationsMockup;
